<template>
  <div id="app">
    <component :is="layout">
    </component>
  </div>
</template>

<script>
import blankLayout from '@/layouts/blankLayout.vue'
import dashboardLayout from '@/layouts/dashboardLayout.vue'

export default {
    name: 'App',
    props: {
        msg: String
    },
    computed: {
        layout() {
            return (this.$route.meta.layout) ? `${this.$route.meta.layout}-layout` : 'blank-layout'
        }
    },
    components: {
        'blank-layout': blankLayout,
        'dashboard-layout': dashboardLayout
    }
}
</script>
